import { identity } from 'lodash';
import React from 'react';
import { ExternalTranslationsContext } from './external-translations-context';
import { TranslationsContext } from './translations-context';
function TranslationsProvider(props) {
    const ctx = React.useContext(ExternalTranslationsContext);
    const isTranslateDebug = typeof window !== 'undefined' && window.location.search.includes('debug-translate');
    return (React.createElement(TranslationsContext.Provider, { value: React.useMemo(() => {
            const value = props.t !== undefined ? { t: props.t } : ctx;
            return isTranslateDebug ? { t: identity } : value;
        }, [props.t, ctx, isTranslateDebug]) }, props.children));
}
export default React.memo(TranslationsProvider);
//# sourceMappingURL=translations-provider.js.map